import React, { useEffect, useState } from "react";
import { Provider } from 'react-redux';
import store from '../store';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useLocation,
    Redirect,
    useHistory
} from "react-router-dom";
import Home from '../containers/Home'
import Screen404 from "../containers/screen404";
import login from "../containers/Login";
import ForgotPass from "../containers/forgotPass";
import NewPassword from "../containers/newPassword";
import SuccessChangePass from "../containers/successChangePass";
import Constant from "../library/Constant";
import PreviewFAQ from "../containers/PreviewFAQ";
import PreviewTNC from "../containers/PreviewTNC";
import PreviewPP from "../containers/PreviewPP";
import PreviewPromosi from "../containers/PreviewPromosi";
import api from "../containers/api";
import format from "date-fns/format";
// This site has 3 pages, all of which are rendered
// dynamically in the browser (not server rendered).
//
// Although the page does not ever refresh, notice how
// React Router keeps the URL up to date as you navigate
// through the site. This preserves the browser history,
// making sure things like the back button and bookmarks
// work properly.

export default function BasicExample() {
    const [id, setId] = useState("")
    const history = useHistory()
    const [load, setLoad] = useState(false)

    useEffect(() => {
        getApiKey()
    }, [])

    let page = window.location.href
    const getApiKey = () => {
        console.log('INI page')
        console.log(page);
        let id = String(page).split('/')
        console.log(id);
        let idx = id.findIndex((val) => val === 'medapp-webadmin')
        if (idx > -1) {
            if (Number.isInteger(Number(id[idx + 1]))) {
                let payload = {
                    unique_url: `${id[idx + 1]}${format(new Date(), 'yyMMddHHmm')}`
                }
                console.log(idx, id, payload);
                api.create().checkApiKey(payload).then(res => {
                    console.log(res);
                    if (res.data) {
                        if (res.data.status === true) {
                            api.create(res.data.data.x_api_key).getDetailHospital().then(response => {
                                console.log(response);
                                if (response.data) {
                                    if (response.data.status === true) {
                                        let api_key = localStorage.getItem(Constant.API_KEY)
                                        if (res.data.data.x_api_key !== api_key) {
                                            localStorage.setItem(Constant.API_KEY, res.data.data.x_api_key)
                                            localStorage.setItem(Constant.NAMA_RS, response.data.data.name)
                                            localStorage.setItem(Constant.LOGO_RS, response.data.data.media_path)
                                            localStorage.setItem(Constant.ALAMAT_RS, response.data.data.address)
                                            localStorage.setItem(Constant.PHONE_RS, response.data.data.phone)
                                            localStorage.setItem(Constant.DESCRIPTION_RS, response.data.data.description)
                                            localStorage.setItem(Constant.SIPA, response.data.data.sipa)
                                            localStorage.setItem(Constant.APOTEKER, response.data.data.apoteker)
                                            localStorage.setItem(Constant.LOGO_CETAKAN, response.data.data.logo_media_path)
                                            // history.replace('/')
                                            setTimeout(() => {
                                                let idRef = id.findIndex((val) => val === "preview-pp" || val === "preview-tnc")
                                                if (idRef > -1) {
                                                    window.location.replace(`/medapp-webadmin/${id[idx + 2]}`)
                                                    // setLoad(true)
                                                    // window.location.replace('/medapp-webadmin')
                                                } else {
                                                    setLoad(true)
                                                }
                                            }, 200);
                                        } else {
                                            localStorage.setItem(Constant.NAMA_RS, response.data.data.name)
                                            localStorage.setItem(Constant.LOGO_RS, response.data.data.media_path)
                                            localStorage.setItem(Constant.ALAMAT_RS, response.data.data.address)
                                            localStorage.setItem(Constant.PHONE_RS, response.data.data.phone)
                                            localStorage.setItem(Constant.DESCRIPTION_RS, response.data.data.description)
                                            localStorage.setItem(Constant.SIPA, response.data.data.sipa)
                                            localStorage.setItem(Constant.APOTEKER, response.data.data.apoteker)
                                            localStorage.setItem(Constant.LOGO_CETAKAN, response.data.data.logo_media_path)
                                            setTimeout(() => {
                                                let idRef = id.findIndex((val) => val === "preview-pp" || val === "preview-tnc")
                                                if (idRef > -1) {
                                                    window.location.replace(`/medapp-webadmin/${id[idx + 2]}`)
                                                    // setLoad(true)
                                                    // window.location.replace('/medapp-webadmin')
                                                } else {
                                                    setLoad(true)
                                                }
                                            }, 200);
                                        }
                                    } else {
                                        let api_key = localStorage.getItem(Constant.API_KEY)
                                        if (res.data.data.x_api_key !== api_key) {
                                            localStorage.removeItem(Constant.ACCESS_TOKEN)
                                            localStorage.removeItem(Constant.REFRESH_TOKEN)
                                            localStorage.removeItem(Constant.CURRENT_COUNTER)
                                            localStorage.removeItem(Constant.SUB_FACILITY)
                                            // localStorage.setItem(Constant.API_KEY, '')
                                            // window.location.reload()
                                            setLoad(true)
                                        }
                                    }
                                }
                            })
                        } else {
                            localStorage.removeItem(Constant.ACCESS_TOKEN)
                            localStorage.removeItem(Constant.REFRESH_TOKEN)
                            localStorage.removeItem(Constant.CURRENT_COUNTER)
                            localStorage.removeItem(Constant.SUB_FACILITY)
                            // localStorage.setItem(Constant.API_KEY, '')
                            // window.location.reload()
                            setLoad(true)
                        }
                    }
                })
            } else if (localStorage.getItem(Constant.API_KEY) !== "API_KEY") {
                api.create(localStorage.getItem(Constant.API_KEY)).getDetailHospital().then(response => {
                    console.log(response);
                    if (response.data) {
                        if (response.data.status === true) {
                            localStorage.setItem(Constant.NAMA_RS, response.data.data.name)
                            localStorage.setItem(Constant.LOGO_RS, response.data.data.media_path)
                            localStorage.setItem(Constant.ALAMAT_RS, response.data.data.address)
                            localStorage.setItem(Constant.PHONE_RS, response.data.data.phone)
                            localStorage.setItem(Constant.DESCRIPTION_RS, response.data.data.description)
                            localStorage.setItem(Constant.SIPA, response.data.data.sipa)
                            localStorage.setItem(Constant.APOTEKER, response.data.data.apoteker)
                            setLoad(true)
                        }
                    }
                })
            }
        }
    }

    return (
        <Provider store={store}>
            <Router basename={`/medapp-webadmin`}>
                {load && (
                    <Switch>
                        <Route exact path="/">
                            <Redirect
                                to={{
                                    pathname: "/dashboard",
                                    state: {
                                        load: load
                                    }
                                }}
                            />
                        </Route>
                        <Route path="/login" component={login} />
                        <Route path="/forgot-pass" component={ForgotPass} />
                        <Route path="/renew-pass" component={NewPassword} />
                        <Route path="/success-pass" component={SuccessChangePass} />
                        <Route path="/preview" component={PreviewFAQ} />
                        <Route path="/preview-tnc" component={PreviewTNC} />
                        <Route path="/preview-pp" component={PreviewPP} />
                        <Route path="/preview-promosi" component={PreviewPromosi} />
                        <PrivateRoute path="/"><Home /></PrivateRoute>
                        <Route path="*"><Screen404 /></Route>
                    </Switch>
                )}
            </Router>
        </Provider>
    );
}


function PrivateRoute({ children, ...rest }) {
    const logged = localStorage.getItem(Constant.ACCESS_TOKEN) !== null ? true : false
    return (
        <Route
            {...rest}
            render={({ location }) =>logged ? (children) :(<Redirect to={{pathname: "/login",state: { from: location }}}/>)
            }
        />
    );
}